import { createReducer, on } from "@ngrx/store";
import { resetTitle, setTitle } from "./title.actions";

export const titleFeatureKey = "title";

export interface TitleState {
	title: string;
	title_secondary: string;
	title_third: string;
}

export const initialState: TitleState = {
	title: undefined,
	title_secondary: undefined,
	title_third: undefined,
};

export const titleReducer = createReducer(
	initialState,
	on(setTitle, (state, { data, data2, data3 }) => ({
		...state,
		title: data,
		title_secondary: data2,
		title_third: data3,
	})),
	on(resetTitle, () => initialState)
);
